module.exports = __webpack_public_path__ + "static/media/rule.8078a646.png";